module.exports = __webpack_public_path__ + "img/组 51.82e74753.png";